import { render, staticRenderFns } from "./OrganisationBulkUserForm.vue?vue&type=template&id=3f7eb966&scoped=true"
import script from "./OrganisationBulkUserForm.vue?vue&type=script&lang=js"
export * from "./OrganisationBulkUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7eb966",
  null
  
)

export default component.exports